/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Fleet_LabelInputs */

const en_dispatch_fleet_label = /** @type {(inputs: Dispatch_Fleet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fleet`)
};

const fr_dispatch_fleet_label = /** @type {(inputs: Dispatch_Fleet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flotte`)
};

const ms_sg2_dispatch_fleet_label = /** @type {(inputs: Dispatch_Fleet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armada`)
};

/**
* | output |
* | --- |
* | "Fleet" |
*
* @param {Dispatch_Fleet_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_fleet_label = /** @type {((inputs?: Dispatch_Fleet_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Fleet_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_fleet_label(inputs)
	if (locale === "fr") return fr_dispatch_fleet_label(inputs)
	return ms_sg2_dispatch_fleet_label(inputs)
});